import AppConfig from '@/AppConfig';
import { IChatQueryRequest } from '@/types/queryTypes';
import { decodeAuthToken } from '@/utils';
import { createInterceptedFetch } from '@/utils/axios/setupInterceptorsFetch';

export const streamChat = async (
  { botName, sessionId, message }: IChatQueryRequest,
  onChunk: (chunk: string) => void,
  onComplete?: (chunk?: string) => void,
  signal?: AbortSignal
) => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  const interceptedFetch = createInterceptedFetch();
  const response = await interceptedFetch(
    `${AppConfig.POLICY_GPT_BASE_URL}/framework/organisation/${organisationId}/member/${memberId}/v2/${botName}/chat?stream=True`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-session-id': sessionId,
      },
      body: JSON.stringify({
        sessionId,
        question: message,
        contextValues: {},
      }),
      signal,
    },
  );

  if (!response.ok || !response.body) {
    throw new Error('Stream failed to start');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let lastChunk = '';

  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    
    buffer += decoder.decode(value, { stream: true });

    let newlineIndex;
    while ((newlineIndex = buffer.indexOf('\n')) !== -1) {
      const line = buffer.slice(0, newlineIndex).trim();
      buffer = buffer.slice(newlineIndex + 1);
      if (line) {
        onChunk(line);
        lastChunk = line;
      }
    }
  }

  if (buffer.trim()) {
    onChunk(buffer.trim());
    lastChunk = buffer.trim();
  }

  onComplete?.(lastChunk);
};
